import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL } from '@/constants';
import { isRebillStripePlanId } from '@/constants/plans';
import { PaymentDescription } from '@/pages/Paywall/components/PaymentDescription/Description';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import './Description.scss';

export const PaymentOnPageDescription: React.FC<{
  plan: StripeV2SubscriptionPrice | undefined;
  monthlyPlan: StripeV2SubscriptionPrice | undefined;
}> = ({ plan, monthlyPlan }) => {
  if (!plan) {
    return null;
  }

  if (isRebillStripePlanId(plan.id)) {
    return <PaymentDescription monthlyPlan={monthlyPlan} selectedPlan={plan} />;
  }

  switch (plan.id) {
    case 'pro.1w':
    case 'pro.1w_19_99':
      return (
        <UiTypography
          variant="body-small"
          color="neutral-black"
          className="description"
        >
          Please note that your subscription will be automatically renewed at
          full price of <b>${plan.price}</b> at the end of chosen subscription
          term. If you want to manage your subscription, please reach us at{' '}
          <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
            {DIALOGUE_SUPPORT_EMAIL}
          </a>
          .
        </UiTypography>
      );
    case 'pro.1m':
    case 'pro.1m_29_99':
      return (
        <UiTypography
          variant="body-small"
          color="neutral-black"
          className="description"
        >
          Please note that your subscription will be automatically renewed at
          full price of <b>${plan.price}</b> at the end of chosen subscription
          term. If you want to manage your subscription, please reach us at{' '}
          <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
            {DIALOGUE_SUPPORT_EMAIL}
          </a>
          .
        </UiTypography>
      );
    case 'pro.3m':
      return (
        <UiTypography
          variant="body-small"
          color="neutral-black"
          className="description"
        >
          We've automatically applied discount to your subscription price.
          Please note that your subscription will be automatically renewed at
          full price of <b>${plan.price}</b> at the end of chosen subscription
          term. If you want to manage your subscription, please reach us at{' '}
          <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
            {DIALOGUE_SUPPORT_EMAIL}
          </a>
          .
        </UiTypography>
      );
    case 'pro.1y':
      return (
        <UiTypography
          variant="body-small"
          color="neutral-black"
          className="description"
        >
          We've automatically applied discount to your subscription price.
          Please note that your subscription will be automatically renewed at
          full price of <b>${plan.price}</b> at the end of chosen subscription
          term. If you want to manage your subscription, please reach us at{' '}
          <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
            {DIALOGUE_SUPPORT_EMAIL}
          </a>
          .
        </UiTypography>
      );
    default:
      return null;
  }
};
